<script setup lang="ts"></script>

<template>
  <div class="static-content__wrapper">
    <div class="wrapper-title">Kebijakan Privasi</div>
    <div class="wrapper-body">
      <p>
        Kognisi.id, sebagai bagian dari Growth Center (&ldquo;Kognisi.id&rdquo;
        atau &rdquo;kami&rdquo;) berkomitmen untuk melindungi dan menghormati
        keamanan data pribadi setiap pengguna (&ldquo;Pengguna&rdquo; atau
        &ldquo;Anda&rdquo;) saat mengakses dan menggunakan situs
        &ldquo;Kognisi.id e-Course Marketplace &amp; Kognisi.id eCourse&rdquo;,
        maupun setiap fitur, konten dan produk yang kami sediakan (untuk
        selanjutnya secara bersama-sama disebut sebagai &ldquo;Platform&rdquo;).
      </p>

      <p>
        Data yang kami kumpulkan dari Pengguna dan/atau yang Pengguna berikan
        melalui, beserta catatan aktivitas pengguna dalam Platform (&ldquo;Data
        Pribadi&rdquo;) akan dicatat dan disimpan dalam Platform. Data Pribadi
        yang diberikan oleh Pengguna merupakan data yang diserahkan secara sadar
        dan tanpa adanya tekanan atau paksaan dari pihak manapun. Keutuhan dan
        keamanan Data Pribadi, termasuk data account Pengguna (username dan kata
        sandi), juga merupakan sepenuhnya tanggung jawab Pengguna. Kami tidak
        bertanggung jawab dan tidak dapat dimintakan pertanggungjawaban atas
        penyalahgunaan data tersebut yang dikarenakan kelalaian Pengguna.
      </p>

      <p>
        Dengan mengakses dan/atau mendaftar Akun pada Platform Kami, Anda
        dan/atau orang tua, wali atau pengampu Anda (jika Anda berusia dibawah
        18 [delapan belas] tahun) menyatakan telah memberikan Data yang benar
        dan sah, menerima dan menyetujui pendekatan dan cara-cara yang
        digambarkan dalam Kebijakan Privasi ini.
      </p>

      <p>
        Adanya Kebijakan Privasi ini adalah sebagai landasan dasar mengenai
        bagaimana Kami menggunakan Data Pribadi, di mana berlaku bagi seluruh
        pengguna Platform. Mohon membaca Kebijakan Privasi Kami dengan seksama
        sehingga Anda dapat memahami pendekatan dan cara Kami dalam menggunakan
        informasi tersebut.
      </p>

      <section id="perolehan_dan_pengumpulan_data_pengguna">
        <h4 class="wrapper-body__subtitle">
          A. Perolehan dan Pengumpulan Data Pengguna
        </h4>
        <ol>
          <li class="font-medium mb-4">
            Data yang Pengguna berikan secara mandiri
            <p class="font-normal mb-0 ml-0 mt-2">
              Data ini meliputi informasi yang Anda berikan ketika mendaftar
              pada Platform Kami, menghubungi Kami melalui media apa saja,
              menggunakan layanan-layanan dan/atau fitur-fitur pada Platform,
              berpartisipasi dalam diskusi online atau fungsi media sosial lain
              pada Platform Kami, mengikuti promosi, atau survei, serta ketika
              Anda melaporkan masalah dengan Platform Kami. Informasi yang Anda
              berikan dapat meliputi nama, alamat, alamat surat elektronik,
              nomor telepon,informasi finansial dan kartu kredit, deskripsi
              pribadi, foto, dan data lainnya. Kami dapat meminta Anda untuk
              melakukan verifikasi terhadap informasi yang Anda berikan, untuk
              memastikan akurasi dari informasi tersebut.
            </p>
          </li>
          <li class="font-medium mb-4">
            Data yang Kami kumpulkan
            <div class="font-normal mt-2">
              <p class="mb-0">
                Data yang terekam saat Pengguna menggunakan Platform, termasuk
                tetapi tidak terbatas pada:
              </p>
              <ol class="child-list pl-0" type="1">
                <li class="pl-3">
                  Data berupa waktu Kandidat menggunakan Platform dan informasi
                  teknis, meliputi alamat Protokol Internet (IP address) yang
                  digunakan untuk menghubungkan komputer Anda dengan internet,
                  informasi log in Anda, jenis dan versi perambah (browser) yang
                  digunakan, pengaturan zona waktu, jenis dan versi ekstensi
                  perambah (browser plug-in), sistem operasi dan platform;
                </li>
                <li class="pl-3">
                  Data Pengguna yang diperoleh melalui cookies, sessions,
                  dan/atau teknologi serupa yang menciptakan tanda pengenal
                  unik;
                </li>
                <li class="pl-3">
                  Data perangkat, termasuk tetapi tidak terbatas pada jenis
                  perangkat yang digunakan untuk mengakses Platform;
                </li>
              </ol>
            </div>
          </li>
          <li class="font-medium mb-4">
            Data yang Kami terima dari sumber lain

            <div class="mt-2">
              <ol class="child-list ml-2" type="1">
                <li>Penyedia layanan pemasaran</li>
                <li>Sumber yang tersedia secara umum.</li>
                <li>
                  Jika Anda menggunakan situs lain yang Kami operasikan atau
                  layanan lain yang Kami sediakan.
                </li>
              </ol>
            </div>

            <p class="font-normal mt-6">
              Kami akan mengambil langkah-langkah dalam batas kewajaran untuk
              melakukan verifikasi terhadap informasi yang Kami dapatkan dari
              sumber lain sesuai dengan Peraturan yang Berlaku.
            </p>
          </li>
        </ol>
      </section>

      <section id="penggunaan_data">
        <h4 class="wrapper-body__subtitle">B. Penggunaan Data</h4>
        <p class="mb-0">
          Kami menggunakan Informasi Pribadi dengan cara-cara berikut:
        </p>
        <ol>
          <li>
            Membantu Pengguna pada saat berkomunikasi dengan pihak Kognisi.id by
            Growth Center;
          </li>
          <li>
            Menghubungi Pengguna melalui email, surat, telepon, dan media-media
            lainnya, termasuk tetapi tidak terbatas untuk mengingatkan Pengguna
            agar menggunakan fitur-fitur Kognisi.id by Growth Center;
          </li>
          <li>
            Menganalisis data Pengguna untuk tujuan penelitian dan pengembangan
            fitur-fitur Platform;
          </li>
          <li>
            Menginformasikan kepada Kandidat dan Perusahaan mengenai produk,
            studi, survei, dan hal-hal lain baik melalui Platform ataupun
            media-media yang disebutkan dalam point nomor 2;
          </li>
          <li>
            Dalam keadaan khusus, terdapat kemungkinan Kognisi.id by Growth
            Center perlu membuka atau mengungkapkan data Pengguna untuk tujuan
            penegakan hukum atau untuk memenuhi persyaratan hukum yang berlaku.
          </li>
        </ol>
      </section>

      <section id="pengungkapan_data_pengguna">
        <h4 class="wrapper-body__subtitle">C. Pengungkapan Data Pengguna</h4>
        <p class="mb-0">
          Kognisi.id by Growth Center menjamin tidak ada transaksi, penagihan,
          distribusi, atau peminjaman data pribadi Pengguna kepada pihak ketiga,
          tanpa mendapatkan izin dari Pengguna, kecuali dalam hal-hal sebagai
          berikut:
        </p>

        <ol class="indented-list">
          <li>
            Dibutuhkan adanya pengungkapan data Pengguna kepada Perusahaan yang
            membantu Kognisi.id by Growth Center dalam memberikan pelayanan yang
            paling cocok. Pengungkapan data Pengguna kepada Perusahaan bersifat
            pengungkapan seminimal mungkin.
          </li>
          <li>
            Dibutuhkan adanya komunikasi langsung antara Pengguna dan Perusahaan
            ataupun pihak ketiga lainnya agar layanan yang diberikan Kognisi.id
            by Growth Center merupakan layanan yang terbaik;
          </li>
          <li>
            Kognisi.id by Growth Center dapat menggunakan data Pengguna dalam
            upaya mematuhi kewajiban hukum dan/atau adanya permintaan yang sah
            dari aparat penegak hukum.
          </li>
        </ol>
      </section>

      <section id="cookies">
        <h4 class="wrapper-body__subtitle">D. Cookies</h4>

        <p>
          Kognisi.id by Growth Center menjamin tidak ada transaksi, penagihan,
          distribusi, atau peminjaman data pribadi Pengguna kepada pihak ketiga,
          tanpa mendapatkan izin dari Pengguna, kecuali dalam hal-hal sebagai
          berikut:
        </p>

        <ol>
          <li>
            Cookies adalah file atau tempat penyimpanan data kecil yang terdapat
            pada browser yang secara otomatis akan menyimpan
            pengaturan/preferensi pengguna selama mengunjungi/menelusuri situs
            Kognisi.id yang Kami simpan pada browser atau hard drive komputer
            Anda atas persetujuan Anda.
          </li>
          <li>
            Pengguna dapat menentukan pilihan untuk melakukan pengaturan Cookies
            melalui pengaturan web browser pengguna masing-masing, termasuk
            memilih atau menolak Cookies. Namun dengan melakukan pengaturan
            tersebut, kinerja pelayanan pada saat pengguna akses menuju situs
            Kognisi.id dapat berpengaruh, dan tidak dapat bekerja maksimal untuk
            layanan kepada pengguna.
          </li>
          <li>
            Kognisi.id menggunakan Google Analytics, dimana data yang diperoleh
            dari penggunaan Google Analytics meliputi alamat IP pengguna, jenis
            perangkat pengguna. Data yang diperoleh ini digunakan oleh
            Kognisi.id untuk pengembangan situs, konten dan periklanan. Pengguna
            dapat memilih untuk tidak dapat terakses/terdeteksi oleh Google
            Analytics dengan mengunduh Google Analytics Opt-Out Add-On pada web
            browser pengguna masing-masing.
          </li>
        </ol>
      </section>

      <section id="penyimpanan_dan_penghapusan_informasi">
        <h4 class="wrapper-body__subtitle">
          E. Penyimpanan dan Penghapusan Informasi
        </h4>

        <p>
          Kognisi.id by Growth Center akan menyimpan data dan informasi Pengguna
          selama akun Pengguna tetap aktif. Anda dapat memohon untuk penghapusan
          Data Pribadi Anda pada Platform atau menarik persetujuan Anda untuk
          setiap atau segala pengumpulan, penggunaan atau pengungkapan Data
          Pribadi Anda dengan memberikan pemberitahuan dengan cara menghubungi
          layanan pelanggan kami pada halaman kontak. Apabila akan menghapus
          data dan informasi pengguna, Kognisi.id akan melakukan penghapusan
          data dan informasi Pengguna sesuai dengan ketentuan peraturan hukum
          yang berlaku.
        </p>
      </section>

      <section id="perubahan_kebijakan_privasi">
        <h4 class="wrapper-body__subtitle">F. Perubahan Kebijakan Privasi</h4>

        <p>
          Kognisi.id by Growth Center dapat melakukan perubahan atau pembaharuan
          terhadap Kebijakan Privasi ini sewaktu-waktu. Perubahan apa pun yang
          Kami lakukan terhadap Kebijakan Privasi Kami di masa depan akan
          diterbitkan melalui halaman ini dan, ketika dibutuhkan, diberitahukan
          kepada Anda melalui surat elektronik. Oleh karena itu, Kognisi.id
          Menyarankan kepada Pengguna untuk terlebih dahulu memahami Kebijakan
          Privasi Kognisi.id Secara seksama dan memeriksa halaman ini dari waktu
          ke waktu untuk mengetahui perubahan apapun. Dengan menggunakan layanan
          dari Kognisi.id beserta fitur-fiturnya, maka Pengguna dianggap
          menyetujui perubahan-perubahan dalam hal Kebijakan Privasi.
        </p>
      </section>

      <div class="kebijakan-privasi__info">
        <div class="info-title">Hubungi Kami</div>
        <div class="info-body">
          Jika Anda memiliki pertanyaan mengenai Kebijakan Privasi ini atau Anda
          ingin mendapatkan akses dan/atau melakukan koreksi terhadap Informasi
          Pribadi Anda, Anda dapat menghubungi Kami melalui
          <a href="mailto:kognisi@growthcenter.id">kognisi@growthcenter.id</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use './styles.scss';
</style>
